//
// social-index/responsive-detail-view.js - detail view for mobile layouts
//
// Responds to:
//   - si/load-begin       - unbinds row click listeners
//   - si/render-finish    - binds row click listeners
//   - breakpoint change   - removes any open detail views
//
// Hooks:
//   - js-c-si-row-detail-view:     the row detail dropdown that activates on tap on a small screen
//   - js-si-header-sort-col-title: the header titles (used to populate the detail view).
//   - js-c-si-row
//   - js-si-data-col[--total]
//

import create_element from '../../../core/js/helpers/create-element';
import remove_node    from '../../../core/js/helpers/remove-node';
import find_ancestor  from '../../../core/js/helpers/find-ancestor';
import * as collection_listener from '../../../core/js/helpers/collection-listener';

const helpers = require('./helpers');


const el_wrap = document.querySelector('.js-si-table');

function get_header_titles() {
  return Array.from(el_wrap.getElementsByClassName('js-si-header-sort-col-title'))
    .map(item => item.textContent.trim());
}

const headers = get_header_titles();

function init() {
  window.addEventListener('si/load-begin', unbind);
  window.addEventListener('si/render-finish', bind);
  helpers.mq_list.addListener(cb_bp_change);
}
init();

function get_rows() {
  return Array.from(el_wrap.getElementsByClassName('js-c-si-row'));
}

function bind(ev) {
  collection_listener.add(get_rows(), 'click', cb_click);
}

function unbind(ev) {
  collection_listener.remove(get_rows(), 'click', cb_click);
}

function cb_click(ev) {
  if (!helpers.mq_list.matches) {
    return;
  }

  const row = find_ancestor(ev.currentTarget, 'js-c-si-row');
  const is_open = row.classList.contains('s-active');

  close();

  if (!is_open) {
    row.classList.add('s-active');
    insert_detail_view(row);
  }
}

function close() {
  get_rows().forEach(function(r) {
    remove_detail_view(r);
    r.classList.remove('s-active');
  });
}

function remove_detail_view(row) {
  row.classList.remove('s-active');

  let detail_view = row.querySelector('.js-c-si-row-detail-view');
  if (detail_view) {
    remove_node(detail_view);
  }
}

function insert_detail_view(row) {
  let values = Array.from(row.querySelectorAll('.js-si-data-col:not(.js-si-data-col--total)'))
    .map((item) => item.textContent);

  let el = create_element(`
    <div class="index-table__detail-view js-c-si-row-detail-view">
      ${headers.map(function(heading, i) {
        return `
          <div class="index-table__detail-view__item" style="animation-delay: ${i / 30}s;">
            <h4 class="index-table__detail-view__heading">${heading}</h4>
            <p class="index-table__detail-view__value">${values[i]}</p>
          </div>
        `;
      }).join('')}
    </div>
  `);

  row.appendChild(el, row.firstElementChild);
  return el;
}

function cb_bp_change() {
  close();
}
